import axios from 'axios';
import { getClientHeaders } from './clientInfo';

const api = axios.create({
  //  baseURL: 'http://localhost:8080',
  baseURL: process.env.REACT_APP_API_URL || 'https://dev.selnitech.online',
  // baseURL: process.env.REACT_APP_API_URL || 'http://192.168.1.155:8080',
  //withCredentials: true,
  // xsrfCookieName: 'XSRF-TOKEN',
  // xsrfHeaderName: 'X-XSRF-TOKEN',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'aud': 'mobile'
  }
});


// Request interceptor
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    try {
      const clientHeaders = await getClientHeaders();
      config.headers = { ...(config.headers || {}), ...clientHeaders };
    } catch (_) {
      // If client info fails, continue without blocking the request
    }
    return config;
  },
  error => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Remove token but don't redirect yet
      localStorage.removeItem('token');
      console.error('Auth failed - token removed', error.response);
      // Return error instead of redirecting
      return Promise.reject(error);
    }
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);


const apiMultiPart = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://dev.selnitech.online',
  // baseURL: process.env.REACT_APP_API_URL || 'http://192.168.1.155:8080',
  //withCredentials: true,
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
    'aud': 'mobile'
  }
});
apiMultiPart.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    try {
      const clientHeaders = await getClientHeaders();
      config.headers = { ...(config.headers || {}), ...clientHeaders };
    } catch (_) {
      // non-blocking
    }
    return config;
  },
  error => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);
apiMultiPart.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Remove token but don't redirect yet
      localStorage.removeItem('token');
      console.error('Auth failed - token removed', error.response);
      // Return error instead of redirecting
      return Promise.reject(error);
    }
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default api;
export { apiMultiPart };